import produce from 'immer';
import {
	FETCH_LOCATIONS_FAILED,
	FETCH_LOCATIONS_FULFILLED,
	FETCH_LOCATIONS_PENDING,
} from '../constants/actions/locationsActions';
import ILocationsReducer from '../interfaces/reducers/locationsReducer';

const initialValues: ILocationsReducer = {
	locations: null,
	locationsLoading: false,
	locationsError: false,
};

const locationsReducer = produce((draft: ILocationsReducer, action) => {
	switch (action.type) {
		case FETCH_LOCATIONS_PENDING: {
			draft.locationsLoading = true;
			draft.locationsError = false;
			break;
		}
		case FETCH_LOCATIONS_FULFILLED: {
			draft.locationsLoading = false;
			draft.locations = action.payload.locations;
			draft.locationsError = false;
			break;
		}
		case FETCH_LOCATIONS_FAILED: {
			draft.locationsLoading = false;
			draft.locationsError = true;
			break;
		}
		default: {
			break;
		}
	}
}, initialValues);

export default locationsReducer;
